import React, {
    useState,
    useRef,
    useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import { ErrorBar } from "../../Components/ErrorBar";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { Help_GridChart } from "../Help/Help_Grids";
import { useCallback } from "react";
import { autoSizeStrategy, columnTypes, defaultColDef, UpdateColumnGroupIds, UpdateTooltips } from "../../Pages/GridScenario";
import { useLayoutEffect } from "react";
import { v4 as uuidv4 } from "uuid";



const GridChart = ({
    height,
    clientData,
    client_,
    dataSet_,
    gridRef,
}) => {
    const [chartData, setChartData] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [columnDefs, setColumnDefs] = useState([]);
    const [errmsg, setErrmsg] = useState("")


    // load data from sever
    // useEffect(() => {
    //     setErrmsg("")
    //     Update(client_, dataSet_)
    // }, [clientData]);


    useLayoutEffect(() => {
        setErrmsg("")
        Update(client_, dataSet_)
    }, [client_, dataSet_, clientData])

    const Update = (cl, ds) => {
        if (clientData && cl && ds) {
            setChartData(clientData[cl][ds]);

            console.log("Set Col and Data")

            let headers = UpdateColumnGroupIds(clientData[cl][ds].Headers, "")
            //headers = UpdateTooltips(headers)
            // console.log(headers)
            setColumnDefs(headers);
            setRowData(clientData[cl][ds].Data);
        }
    };

    // const onRowDataUpdated = useCallback((event) => {
    //     event.api.autoSizeAllColumns();
    // }, []);

    const onRowDataUpdated = (event) => {
        console.log("Row Update all columns")
        //gridRef.current.api.autoSizeAllColumns(false);
        event.api.autoSizeAllColumns(false);


    }


    return (
        <Box sx={{ p: 4 }}>
            {(chartData !== null &&
                <Stack spacing={4}>

                    <Typography
                        id="s-die-Income-calc"
                        variant="h6"
                        gutterBottom
                        sx={{ pt: 1, pl: 3 }}
                    >
                        {chartData.Title.text}
                    </Typography>


                    <div
                        className="ag-theme-alpine"
                        style={{
                            // width: "100%",
                            height: height - 40
                        }}
                    >
                        <AgGridReact
                            //key={uuidv4()}
                            ref={gridRef}
                            rowData={rowData} // Row Data for Rows
                            rowHeight={32}
                            columnDefs={columnDefs} // Column Defs for Columns
                            defaultColDef={defaultColDef} // Default Column Properties
                            columnTypes={columnTypes}
                            tooltipShowDelay={1200}
                            //animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            //suppressCellSelection={true}
                            //rowSelection= {mode="singleRow"}
                            onRowDataUpdated={onRowDataUpdated}
                            onGridReady={onRowDataUpdated}
                            autoSizeStrategy={autoSizeStrategy}
                            autoSizePadding={8}

                        // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        // overlayNoRowsTemplate={none}
                        />
                    </div>
                    <Help_GridChart />
                    <ErrorBar error={errmsg} />
                </Stack>
            )}
        </Box>
    );
};

export default GridChart;
